import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'dwoDate',
  standalone: false,
})
export class DwoDatePipe implements PipeTransform {
  private datePipe: DatePipe;

  constructor() {
    this.datePipe = new DatePipe('en');
  }

  transform(value: any): string {
    const date = this.datePipe.transform(value, 'dd-MMM-yyyy');
    return date ? date.toUpperCase() : '';
  }
}
